import { useEffect } from "react";
import {
  Modal,
  Button,
  Form,
  Input,
  Select,
  DatePicker,
  message,
  Row,
  Col,
} from "antd";
import { CloseOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";
import dayjs from "dayjs";
import {
  addmedicine,
  updatemedicine,
} from "../../services/doctor/medicine/medicine";
import { useMessageApi } from "../../services/message api/MessageProvider";

export default function MedicineModal({
  show,
  onHide,

  type,
  record,
  name,
}) {
  console.log("Received name prop:", name);
  const [form] = Form.useForm();

  const dosageOptions = ["Morning", "Afternoon", "Evening", "Night", "Bedtime"];
  const instructionOptions = [
    "Before Food",
    "After Food",
    "Empty Stomach",
    "Bedtime",
  ];
const medicineTypes = [
  "Tablet",
  "Syrup",
  "Injection",
  "Drop",
  "Cream",
  "Capsule",
  "Powder",
  "Sachet",
  "Lotion",
  "Gel",
  "Ointment",
  "Suspension",
  "Spray",
  "Soap",
  "Inhaler",
  "Liquid",
  "Respule",
  "Shampoo",
  "Suppository",
  "Solution",
  "Granule",
  "Oil",
  "Milk",
  "Rotacap",
  "Infusion",
  "Other",
  "Aplicap",
  "Bar",
  "Face Wash",
  "Lozenger",
  "Balm",
  "Vial",
  "Mouthwash",
  "Device",
  "Patch",
  "Serum",
  "Enema",
  "Mouth Paint",
  "Pessary",
  "Tube",
  "Expectorant",
  "Kit",
  "Biscuit",
  "Emulsion",
  "Jelly",
  "Paste",
  "Transpule",
  "Cartridge",
  "Hygiene",
  "Paint",
  "Elixer",
  "Spacer",
  "Pen",
  "Liniment",
  "Gum Paint",
  "Wash Kit",
  "Glue",
  "Conditioner",
  "Toothpaste",
  "Transcap",
  "Mask",
  "Shield",
  "Transhaler",
  "Gargle",
  "Linctus",
  "Gum Astringent",
  "Octocap",
  "Strip",
  "Nebuliser",
  "Vaccine",
  "Dressing",
  "Oral Solution",
  "Softule",
  "Aerosol",
  "Bead",
  "Block",
  "Catheter",
  "Cellular Sheet",
  "Cement",
  "Chewable Gel",
  "Cigarette",
  "Cloth",
  "Concentrate",
  "Cone",
  "Core",
  "Crystal",
  "Culture",
  "Diaphragm",
  "Disc",
  "Dosing",
  "Douche",
  "Extract",
  "Film",
  "Gas",
  "Generator",
  "Globule",
  "Graft",
  "Gum",
  "Implant",
  "Inhalant",
  "Injectable",
  "Injectable Foam",
  "Insert",
  "Intrauterine Device",
  "Irrigant",
  "Liner",
  "Lipstick",
  "Not Applicable",
  "Note",
  "Packing",
  "Pastille",
  "Pellet",
  "Pill",
  "Plaster",
  "Poultice",
  "Ring",
  "Rinse",
  "Salve",
  "Sponge",
  "Stick",
  "Suture",
  "Swab",
  "System",
  "Tampon",
  "Tape",
  "Tincture",
  "Troche",
  "Wafer",
];
  useEffect(() => {
    if (type === "edit" && record) {
      form.setFieldsValue({
        company_name: record.company_name || "",
        contain: record.contain || "",
        name: record.name || "",
        type: record.type || "",
        dosage_time: record.dosage_time || [],
        instruction: record.instruction || "",
      });
    } else {
      form.resetFields();
      form.setFieldsValue({ name: name || "" });
    }
  }, [type, record, form]);

  message.config({
    top: 100, // distance from top
    duration: 3,
    placement: "topRight", // <-- key part for right side
  });
  const messageApi = useMessageApi();

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const formData = {
        ...values,
      };

      let result;

      if (type === "edit") {
        result = await updatemedicine(record.id, formData);
      } else {
        result = await addmedicine(formData);
      }

      if (result?.success) {
        messageApi.open({
          type: "success",
          content:
            type === "edit"
              ? "Medicine updated successfully!"
              : "Medicine added successfully!",
        });
        console.log("Form Data Submitted:", formData);
        onHide(result?.data);

      } else {
        let errorMsg = "Something went wrong";

        if (typeof result?.error === "string") {
          errorMsg = result.error;
        } else if (typeof result?.error === "object") {
          const key = Object.keys(result.error)[0];
          errorMsg = result.error[key][0];
        }

        messageApi.error(errorMsg);
      }
    } catch (error) {
      messageApi.error(error.message || "Submission failed");
      console.log("catch error:", error);
    }
  };

  return (
    <>
      <Modal
        title={type === "edit" ? "Edit Medicine" : "Add Medicine"}
        open={show}
        onCancel={()=>onHide(null)}
        centered
        maskClosable={false} 
        keyboard={false}
        footer={[
          <Button key="cancel" onCancel={()=>onHide(null)}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={handleSubmit}>
            {type === "edit" ? "Save Changes" : "Add"}
          </Button>,
        ]}
        width={800}
        className="vitals-modal"
        closeIcon={<CloseOutlined />}
      >
        <Form layout="vertical" form={form}>
          {/* Row 1: Company Name + Contain */}
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Company Name"
                name="company_name"
                rules={[
                  { required: false, message: "Please enter company name" },
                ]}
              >
                <Input placeholder="Enter company name" />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                label="Contain"
                name="contain"
                rules={[
                  {
                    required: false,
                    message: "Please enter contain description",
                  },
                ]}
              >
                <Input placeholder="Enter contain description" />
              </Form.Item>
            </Col>
          </Row>

          {/* Row 2: Name + Type */}
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Name"
                name="name"
                rules={[
                  { required: true, message: "Please enter medicine name" },
                ]}
              >
                <Input placeholder="Enter medicine name" />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                label="Type"
                name="type"
                rules={[{ required: true, message: "Please select type" }]}
              >
                <Select placeholder="Select type">
                  {medicineTypes.map((type) => (
                    <Select.Option key={type} value={type}>
                      {type}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          {/* Row 3: Dosage Time + Instruction */}
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Dosage Time"
                name="dosage_time"
                rules={[
                  { required: false, message: "Please select dosage time" },
                ]}
              >
                <Select mode="multiple" placeholder="Select dosage time">
                  {dosageOptions.map((time) => (
                    <Select.Option key={time} value={time}>
                      {time}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                label="Instruction"
                name="instruction"
                rules={[
                  { required: false, message: "Please select instruction" },
                ]}
              >
                <Select placeholder="Select instruction">
                  {instructionOptions.map((inst) => (
                    <Select.Option key={inst} value={inst}>
                      {inst}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
}

MedicineModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  refresh: PropTypes.func, // optional: to refresh data on save
  type: PropTypes.string,
  record: PropTypes.object,
  onSuccess: PropTypes.func, // optional: to refresh data on save
  name: PropTypes.string, // optional: to pre-fill medicine name
};
